// extracted by mini-css-extract-plugin
export var aggregationCell = "_2a-m";
export var aggregationRow = "_2a-l";
export var borderlessSpinnerContainer = "_2a-3";
export var cardLayout = "_2a-6";
export var cardLayoutPageControl = "_2a-7";
export var closeIcon = "_2a-e";
export var columnHeaderSurface = "_2a-a";
export var columnHeaderSurfaceDragOverlay = "_2a-u";
export var columnHeaderSurfaceResizing = "_2a-r";
export var contextMenuAnchor = "_2a-1";
export var draggableColumnHeader = "_2a-s";
export var draggableColumnHeaderOverlay = "_2a-t";
export var expandIcon = "_2a-f";
export var expanded = "_2a-g";
export var filterDropdown = "_2a-h";
export var filterDropdownDivider = "_2a-c";
export var filterDropdownHeader = "_2a-k";
export var filterDropdownItem = "_2a-j";
export var filterDropdownModal = "_2a-i _2a-h";
export var filterItem = "_2a-b";
export var normalCellWithAdjustableBorder = "_2a-d";
export var pinButtonContainer = "_2a-n";
export var pinIcon = "_2a-o";
export var pinIconActive = "_2a-p";
export var spinner = "_2a-0";
export var spinnerContainer = "_2a-2";
export var tableContainer = "_2a-4";
export var tableContentDraggingColumns = "_2a-9";
export var tableContentInner = "_2a-8";
export var tableContentWrapper = "_2a-5";
export var viewButtonContainer = "_2a-q";